<template>
  <div>
    <v-data-table :items="items" :headers="headers">
      <template v-slot:item.actions="{item}">
        <slot name="actions" v-bind:item="item"></slot>
      </template>
      <template v-slot:item.dateFrom="{item}">{{item.dateFrom | dateFormat}}</template>
      <template v-slot:item.dateTo="{item}">{{item.dateTo | dateFormat}}</template>
      <template v-slot:item.timeFrom="{item}">{{item.timeFrom | timeFormat}}</template>
      <template v-slot:item.timeTo="{item}">{{item.timeTo | timeFormat}}</template>
      <template v-slot:item.attachment="{item}">
        <slot name="attachment" v-bind:item="item"></slot>
      </template>
    </v-data-table>
  </div>
</template>
<script>
const API_ENDPOINT = "/api/seminarTraining";
export default {
  props: {
    empCode: {
      default: null,
      type: String
    }
  },
  data: () => ({
    items: [],
    headers: [
      {
        text: "",
        value: "actions",
        sortable: false
      },
      {
        text: "Seminar Title",
        value: "semTitleDesc",
        sortable: false
      },
      {
        text: "Seminar Class",
        value: "semClassDesc",
        sortable: false
      },
      {
        text: "Seminar Type",
        value: "semTypeDesc",
        sortable: false
      },
      {
        text: "Assessment Result",
        value: "attachment",
        sortable: false
      },
      {
        text: "Date From",
        value: "dateFrom",
        sortable: false
      },
      {
        text: "Date To",
        value: "dateTo",
        sortable: false
      },
      {
        text: "Hours/Day",
        value: "hours",
        sortable: false
      },
      {
        text: "Cost",
        value: "cost",
        sortable: false
      },
      {
        text: "Provider",
        value: "provider",
        sortable: false
      },
      {
        text: "Venue",
        value: "venue",
        sortable: false
      },
      {
        text: "Remarks",
        value: "Remarks",
        sortable: false
      },
      {
        text: "Duration",
        value: "duration",
        sortable: false
      },
      {
        text: "Time From",
        value: "timeFrom",
        sortable: false
      },
      {
        text: "Time To",
        value: "timeTo",
        sortable: false
      },
      {
        text: "Reference",
        value: "reqRefNo",
        sortable: false
      },
      {
        text: "Month No",
        value: "monthNo",
        sortable: false
      },
      {
        text: "With Contract",
        value: "withContract",
        sortable: false
      },
      {
        text: "Org Sponsor",
        value: "orgSponsor",
        sortable: false
      },
      {
        text: "Comp. Sponsor",
        value: "compSponsor",
        sortable: false
      },
      {
        text: "Ratings",
        value: "ratings",
        sortable: false
      }
      // {
      //   text: "Attachment",
      //   value: "attachment",
      //   sortable: false
      // }
    ]
  }),
  methods: {
    getByEmpCode(empCode) {
      this.$axios
        .get(`${API_ENDPOINT}/${empCode}`)
        .then(({ data }) => {
          this.items = data;
        })
        .catch(({ response }) => {
          this.$toast.success(response.data.message);
        });
    }
  },
  created() {
    this.getByEmpCode(this.empCode);
  },
  watch: {
    empCode(val) {
      this.getByEmpCode(val);
    }
  }
};
</script>